import y, { useRef as w, useEffect as a, useMemo as k } from "react";
import { sendToLurker as P } from "../../../Lurker/Lurker.js";
import { useScrollLock as B } from "../../services/useScrollLock.js";
import { useOverflowNavigation as N } from "../../services/useOverflowNavigation.js";
import { useClickOutsideOverflow as R } from "../../services/useClickOutsideOverflow.js";
import { ProOverflowMenu as _ } from "./components/ProOverflowMenu/index.js";
import { DefaultOverflowMenu as x } from "./components/DefaultOverflowMenu/index.js";
import { addMouseflowVariable as q } from "../../../../helpers/mouseflowHandler.js";
const D = (r, e) => {
    P({
      eventType: r,
      objectName: "navigation_bar",
      objectDetail: "menu",
      data: e
    });
  },
  E = _ref => {
    let {
      headerWrapperRef: r,
      openSubMenu: e,
      setOpenSubMenu: l,
      accountInfo: i,
      fixed: M,
      hasNavbar: u,
      showProMenu: o
    } = _ref;
    var p, c, f;
    const s = w(!!e),
      t = w(null),
      {
        isLogged: n,
        isAutosPro: m
      } = i,
      {
        lockScroll: d,
        unlockScroll: v
      } = B(),
      b = (p = r.current) == null ? void 0 : p.querySelector("[data-header-burger-menu]"),
      S = (c = r.current) == null ? void 0 : c.querySelector('[data-ds-component="DS-Profile-Button"]'),
      g = (f = r.current) == null ? void 0 : f.querySelector(".olx-header__overlay");
    N({
      openSubMenu: e,
      setOpenSubMenu: l,
      menuButton: b,
      profileButton: S,
      wrapperRef: t
    }), R({
      openSubMenu: e,
      setOpenSubMenu: l,
      menuButton: b,
      profileButton: S,
      wrapperRef: t,
      overlay: g
    }), a(() => {
      const O = window.document.body.clientWidth < 840;
      e && O ? d() : v();
    }, [d, e, v]), a(() => {
      if (!s.current) {
        s.current = !0;
        return;
      }
      D(e ? "impression" : "close", {
        isAutosPro: m,
        menuPro: o,
        login: n,
        hasNavbar: u
      });
    }, [e, o, m, n, u]);
    const h = k(() => o ? _ : x, [o]);
    return a(() => {
      e && q("opened-header-menu", n ? o ? "pro" : "pri" : "unlogged");
    }, [o, e, n]), y.createElement(h, {
      openSubMenu: e,
      accountInfo: i,
      hasNavbar: u,
      fixed: M,
      wrapperRef: t
    });
  };
export { E as OverflowMenu };